import { render, staticRenderFns } from "./content-directory.vue?vue&type=template&id=37615bb8&scoped=true"
import script from "./content-directory.vue?vue&type=script&lang=js"
export * from "./content-directory.vue?vue&type=script&lang=js"
import style0 from "./content-directory.vue?vue&type=style&index=0&id=37615bb8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37615bb8",
  null
  
)

export default component.exports